<template>
  <ul v-if="confNavigation.socials.length" class="socials">
    <li v-for="social, i in confNavigation.socials" :key="social.link + i">
      <a :title="social.title" :href="social.link" target="_blank" rel="noopener">
        <i :class="social.icon"></i>
      </a>
    </li>
  </ul>
</template>

<script setup>
const { confNavigation } = useConfig()
</script>

<style lang="scss">
.socials {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 0;
  margin: 0 -5px 20px;
  font-size: 1.125rem;
  list-style-type: none;
  li {
    padding: 0 5px;
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      border: 1px solid #eaedf0;
      border-radius: 50%;
    }
  }
}
</style>
